import { Component, Input } from '@angular/core';
import { Environment } from '../../environment';
import { ProductName } from '../../graphql-client/graphql';

@Component({
  selector: 'finders-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent {
  @Input() onResultsPage = false;
  public product: ProductName;
  public locationsText = 'pharmacies or treatment sites';

  constructor(private env: Environment) {
    this.product = this.env.product;

    if (this.product === ProductName.Evenity) {
      this.locationsText = 'treatment sites';
    }
  }
}
